import React from 'react';
import PropTypes from 'prop-types';

const EquipmentSearchResults = (props) => {

    const {searchResults} = props;

    const labelStyle = {
        fontSize: '16px',
        display: 'inline-block',
        paddingBottom: '10px',
        paddingTop: '10px'
    };

    if (!searchResults) {
        return null;
    }

    return (
        <div>
            <h5>{searchResults.get('itemDescription')}</h5>
            <label style={labelStyle}>Serial #:</label><br/>{searchResults.get('serialNumber') || 'N/A'}<br/>
            <label style={labelStyle}>Status:</label><br/>{searchResults.get('equipStatusFullDesc') || 'N/A'}<br/>
            <label style={labelStyle}>Mac:</label><br/> {searchResults.get('equipmentAddress') || 'N/A'}<br/>
            <label style={labelStyle}>Last Changed Date:</label><br/> {searchResults.get('changeDateTime') || 'N/A'}<br/>
            <label style={labelStyle}>Last Changed User:</label><br/> {searchResults.get('lastChangeUserID') || 'N/A'}<br/>
            <label style={labelStyle}>Account Number:</label><br/> {searchResults.get('accountNumber') || 'N/A'}<br/>

        </div>

    );
};

EquipmentSearchResults.propTypes = {
    searchResults: PropTypes.object

};
export default EquipmentSearchResults;



// WEBPACK FOOTER //
// ./src/components/equipment/EquipmentSearchResults.js